import { render } from "./schedule-saturday.vue?vue&type=template&id=fd7ebd8a"
import script from "./schedule-saturday.vue?vue&type=script&lang=js"
export * from "./schedule-saturday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__